module.exports = __webpack_public_path__ + "static/media/car.0f5f7a16.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/carRentPayment/images/car.png
// module id = 611
// module chunks = 0